
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogRT(): TemplateResult<dialogRTRootProps> {
    function onClick1() {
        {
            this.discardVehicle();
            window.location.pathname === '/' ? window.location.assign('/pages/search') : this.close();
        }
    }
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', { 'className': 'dialog-content-container' }, _createElement('div', { 'className': 'dialog-header' }, _createElement('div', { 'className': 'dialog-title-container' }, _createElement('div', { 'className': 'dialog-title' }, _translate(`garage_dialog_title`)), _createElement('div', {
        'className': 'close',
        'onClick': this.close
    }, _createElement('svg', {
        'width': '24',
        'height': '24',
        'viewBox': '0 0 24 24',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', {
        'd': 'M19.0742 6.34375L13.417 12.001L19.0742 17.6582L17.6602 19.0723L12.0029 13.415L6.34668 19.0713L4.93262 17.6572L10.5889 12.001L4.93262 6.34473L6.34668 4.93066L12.0029 10.5869L17.6602 4.92969L19.0742 6.34375Z',
        'fill': '#2B2E30'
    }))))), _createElement('div', { 'className': 'dialog-content' }, [this.vehicleList(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item form-check' + (this.isSelected ? ' selected' : '') }, _createElement('div', { 'className': 'select-model-container' }, _createElement('div', { 'className': 'select-model_vehicle form-check-label' }, _createElement('div', {
                            'className': 'select-model_vehicle-container',
                            'onClick': this.selectVehicle
                        }, _createElement('input', {
                            'type': 'radio',
                            'className': 'form-check-input',
                            'readOnly': true,
                            'checked': this.isSelected
                        }), _createElement('label', { 'className': 'select-model form-check-label' }, _createElement('div', { 'className': 'select-model_title' }, this.vehicleBaseValues.join(' ')))), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'width': '24',
                                'height': '24',
                                'viewBox': '0 0 24 24',
                                'fill': 'none',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '8140'
                            }, _createElement('mask', {
                                'id': 'mask0_9245_1887',
                                'style': { maskType: 'alpha' },
                                'maskUnits': 'userSpaceOnUse',
                                'x': '0',
                                'y': '0',
                                'width': '24',
                                'height': '24'
                            }, _createElement('rect', {
                                'width': '24',
                                'height': '24',
                                'fill': '#D9D9D9'
                            })), _createElement('g', { 'mask': 'url(#mask0_9245_1887)' }, _createElement('path', {
                                'd': 'M7.30775 20.4997C6.80908 20.4997 6.38308 20.3232 6.02975 19.97C5.67658 19.6167 5.5 19.1907 5.5 18.692V5.99973H4.5V4.49973H9V3.61523H15V4.49973H19.5V5.99973H18.5V18.692C18.5 19.1972 18.325 19.6247 17.975 19.9747C17.625 20.3247 17.1974 20.4997 16.6923 20.4997H7.30775ZM17 5.99973H7V18.692C7 18.7818 7.02883 18.8556 7.0865 18.9132C7.14417 18.9709 7.21792 18.9997 7.30775 18.9997H16.6923C16.7692 18.9997 16.8398 18.9677 16.9038 18.9035C16.9679 18.8395 17 18.769 17 18.692V5.99973ZM9.404 16.9997H10.9037V7.99973H9.404V16.9997ZM13.0962 16.9997H14.596V7.99973H13.0962V16.9997Z',
                                'fill': '#2B2E30'
                            })))]))));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_Garage_dialog cm_vehicleList' }, _createElement('div', { 'className': 'cm_garage__dialog' }, _createElement('div', { 'className': 'cm_garageDropdown' }, !this.isEmpty ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '140'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]))) : null)));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.vehicleWidget(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-popular',
                                        'disabled': true,
                                        'key': '11901'
                                    }, _translate(`ymm_bar_popular`)),
                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-unpopular',
                                        'disabled': true,
                                        'key': '11904'
                                    }, _translate(`ymm_bar_unpopular`))
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        function scopeShowSelectedValues4() {
                            var showSelectedValues = this.selectedEntries.length;
                            return _createElement('option', {
                                'key': '_current',
                                'value': '_current'
                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                _translate(`select_title`),
                                ' ',
                                this.title
                            ] : null);
                        }
                        function repeatEntry5(entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => this.onChange(entry.term)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '3412'
                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                'className': 'cm_dropdown_hitCount',
                                'key': '3614'
                            }, entry.hitCount) : null);
                        }
                        return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                            'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                            'key': '39'
                        }, this.index || this.index === 0 ? _createElement('span', {
                            'className': 'index',
                            'key': '199'
                        }, '0', this.index + 1) : null, _createElement('select', {
                            'className': 'cm_select_inner-select cm_select__pretty',
                            'onChange': this.onChange,
                            'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                    return _createElement('div', { 'className': 'cm_filterInput' });
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                'aria-label': this.title,
                                'key': '2674'
                            },
                            !this.hideNullOption ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'onClick': () => this.onChange('')
                            }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                            this.loading ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'disabled': true
                            }, _translate(`select_loading`)) : null,
                            !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                        ]) : null);
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_HomeVehicleWidget_dialog cm_vehicle-widget__garage-dialog cm_vehicleWidget' }, _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__home' }, _createElement('div', { 'className': 'cmTemplate_active cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, _translate(`garage_dialog_add_new_vehicle`)), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go cm_button cm_button__primary',
                'onClick': this.selectVehicle,
                'disabled': !this.allowToSetVehicle,
                'role': 'button',
                'tabIndex': this.allowToSetVehicle ? '0' : '-1'
            }, '\n                  ', _translate(`garage_dialog_ymm_bar_submit`), '\n                '))))));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], this.isVehicleSelected ? _createElement('div', {
        'className': 'dialog-button-discard cm_button cm_button__secondary',
        'onClick': onClick1.bind(this),
        'role': 'button',
        'tabIndex': '0',
        'key': '11514'
    }, '\n        ', _translate(`garage_dialog_shop_without_vehicle`), '\n      ') : null)));
}
        export const componentNames = ["cm:vehicleList","cm:filterInput","cm:vehicleWidget"]